import { getRenderingOrder, getSelectedProjectId } from 'owa-timestream-store';
import getStore from '../store';
import isPanning from './isPanning';

export default function getShowMiniMap() {
    const projectId = getSelectedProjectId();
    return getRenderingOrder(projectId).length != 0 && (isPanning() || getStore().showMiniMap);
}
